import { Offering, TotalAvailableSharesResponse } from '@arrived/models';

export const getMinSharesToBuy = (offering: Offering): number => {
  return Math.ceil(offering.minTransactionAmount / offering.sharePrice);
};

interface GetMaxSharesArgs {
  offering: Offering;
  sharesAvailable: TotalAvailableSharesResponse;
}

export const getMaxShares = ({ offering, sharesAvailable }: GetMaxSharesArgs): number => {
  if (sharesAvailable) {
    return sharesAvailable.availableSharesCount;
  }

  return Math.floor(offering.totalShares * 0.098);
};
